export default __webpack_public_path__ + "static/img/2.71ea1c3.png";